import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import Select from '../common/form/select';

import { setModoTela, initForm } from './pedidoOcorrenciaActions';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import LabelAndInputMask from '../common/form/labelAndInputMask';

class PedidoOcorrenciaForm extends Component {

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';
		
        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>

							<Field
								name='datahora_ocorrencia'
								component={LabelAndInputDateTime}
								label='Data/Hora' placeholder='Informe'
								cols='12 6 4 4'
								readOnly={readOnly} />

							<Field
								name='descricao'
								component={LabelAndInput}
								label='Descrição' placeholder='Informe o nome'
								cols='12 12 12 12'
								readOnly={readOnly} />
								
						</Row>
						{this.props.formularioValues.pedido_item.map(item => (
							<Row key={item.id}>
								<LabelAndInput
									label='Cliente' placeholder='Informe o nome'
									cols='12 6 4 4'
									readOnly={'readOnly'}
									value={item.nome_cliente}
									onChange={(data) => {}} />

								<LabelAndInput
									label='Endereço' placeholder='Informe o nome'
									cols='12 6 4 4'
									readOnly={'readOnly'}
									value={item.nome_endereco}
									onChange={(data) => {}} />

								<LabelAndInputMask
									label='Previsão de Entrega'
									placeholder='Informe a data'
									minWidth={180}
									maxWidth={180}
									cols='6 6 2 2'
									mask='99/99/9999 99:99'
									value={item.datahora_previsao_entrega}
									onChange={data => {
										this.props.initForm({
											...this.props.formularioValues,
											pedido_item: this.props.formularioValues.pedido_item.map(itemAux => {
												if (item.id == itemAux.id) {
													return {
														...itemAux,
														datahora_previsao_entrega: data.target.value,
														previsao_alterada: true
													}
												} else {
													return itemAux;
												}
											})
										});
									}} />
							</Row>
						))}
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>

				</Form>
			</ContentCard>
        )
    }


}

PedidoOcorrenciaForm = reduxForm({form: 'pedidoOcorrenciaForm', destroyOnUnmount: false})(PedidoOcorrenciaForm);
const mapStateToProps = state => ({
	sessao: state.auth.pedidoOcorrencia,
	formularioValues: getFormValues('pedidoOcorrenciaForm')(state),
	registro: state.pedidoOcorrencia.registro
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(PedidoOcorrenciaForm);
